module.exports = __webpack_public_path__ + "img/xls.85c2738d.svg";